import React from 'react';



type Props  =  {
  className?: string;
};
export const StickyNotesVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '38' height = '38' viewBox = '0 0 38 38' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = '#0041A0' d = 'M26.7778 10.4444V21.4444H21.2222V27.5556H11.2222V10.4444H26.7778ZM26.7778 8H11.2222C10 8 9 9.1 9 10.4444V27.5556C9 28.9 10 30 11.2222 30H22.3333L29 22.6667V10.4444C29 9.1 28 8 26.7778 8ZM19 21.4444H13.4444V19H19V21.4444ZM24.5556 16.5556H13.4444V14.1111H24.5556V16.5556Z' />
    </svg>
  );
};
